import "@mantine/core/styles.css";
import "./app/global.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { fetchBrand } from "./shared/brand/brand";
import { initI18n } from "./shared/i18n/i18n";

const container = document.getElementById("root");
if (!container) throw new Error("index.html has no #root element");
const root = createRoot(container);

async function start() {
  const brand = await fetchBrand();
  const i18n = await initI18n(brand);
  root.render(
    <StrictMode>
      <App brand={brand} i18n={i18n} />
    </StrictMode>,
  );
}

start().catch(() => {
  // The brand or locale files could not load: show a plain message rather than a blank page.
  const p = document.createElement("p");
  p.textContent = "The application could not start. Please reload the page.";
  p.setAttribute("role", "alert");
  container.replaceChildren(p);
});
